const DEFAULT_FAVICON_PATH = '/favicon.ico';
const UNREAD_FAVICON_PATH = '/favicon_badge.ico';

function setFavicon(href) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  }
  link.href = href;
}

export { setFavicon, DEFAULT_FAVICON_PATH, UNREAD_FAVICON_PATH };